import React from "react";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import { useLocation, Outlet } from "react-router-dom";
import { allRoutes } from "../router/config";
import { IRoute } from "../types";
import BackgroundImage from "../components/BackgroundImage/BackgroundImage";

export const Layout: React.FC = () => {
  const { pathname } = useLocation();

  const isAdminRoutes: string[] = allRoutes
    .filter((route: IRoute) => route.isAdmin || route.withOutHeaderAndFooter)
    .map((route) => `/${route.path}`);

  const isAdminRoute = pathname.startsWith("/admin");
  const isResourcesRoute = pathname.startsWith("/resources");
  const isRouteWithoutLayout = isAdminRoutes.some(
    (routePath) => pathname === routePath || pathname === `${routePath}/`
  );

  const shouldShowBackground = !isAdminRoute && !isResourcesRoute && pathname !== "/";

  return (
    <section style={{ width: "100%", minHeight: "100%" }}>
      {!isRouteWithoutLayout && <Header />}
      {shouldShowBackground && <BackgroundImage />}
      <Outlet />
      {/* Instagram feed temporarily disabled due to Instagram API changes */}
      {/* {!isRouteWithoutLayout && <Instagram />} */}
      {!isRouteWithoutLayout && <Footer />}
    </section>
  );
};
